// extracted by mini-css-extract-plugin
export default {"alphabetContainer":"AlphabetTiles_alphabetContainer__v-cZN","title":"AlphabetTiles_title__JpdU6","tilesGrid":"AlphabetTiles_tilesGrid__VbUC2"};